import React from 'react'
import { Box, Text, Title } from '@mantine/core'
import { useMarketElements, usePricingVersionCache, useVersionRulesCache } from '../../../../hooks/global-job-matching'
import { useParams } from 'react-router'

export const MethodologyStepDetails = () => {
  const params = useParams<{id: string}>()
  const rules = useVersionRulesCache(params.id)
  const version = usePricingVersionCache(params.id)
  const { data: marketElements } = useMarketElements()
  const prioritySelection = rules?.methodology === 'match_priority' ? 'Match Priority' : 'Data Cut Priority'

  const marketDataElementLabels: string[] = []
  rules.marketDataElements?.forEach(mde => {
    const foundElement = marketElements?.payElements?.find(me => me.source_field === mde)
    if (foundElement) marketDataElementLabels.push(foundElement.field_title)
  })

  return (
    <Box>
      <Title order={3} c='black'>Method</Title>
      { version.matchStrategy === 'file' &&
      <Text c='black' size='sm'>Set to use <Text span fw='bold' c='black' size='sm'>{prioritySelection}</Text></Text> }
      <Text c='dimmed' size='sm'>Minimum incumbents {rules.incumbentsMinimum ? 'set to' : 'not set'} <Text span c='black' size='sm'>{rules.incumbentsMinimum && rules.incumbentsMinimum !== 0 ? rules.incumbentsMinimum : ''}</Text></Text>
      <Text c='dimmed' size='sm'>Minimum companies {rules.companiesMinimum ? 'set to' : 'not set'} <Text span c='black' size='sm'>{rules.companiesMinimum && rules.incumbentsMinimum !== 0 ? rules.companiesMinimum : ''}</Text></Text>
      { !!marketDataElementLabels.length &&
      <>
        <Text c='dimmed' size='sm'>Required market data elements for pricing results</Text>
        { marketDataElementLabels.map(label => <Text key={label} c='black' ml={20}>{label}</Text>)}

      </>
      }
    </Box>
  )
}
